import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import ApiClient from '../../helpers/ApiClient';
import Toolbar from '../../components/Toolbar';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, RadioList, FileUpload, ImageUpload, Select, Checkbox, Number} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ActionButton from '../../components/ActionButton';
import SaveButton from '../../components/SaveButton';
import * as naviActions from '../../redux/modules/navi';
import * as tabActions from '../../redux/modules/tabs';
import AppForm from '../../components/AppForm';
import DeleteButton from '../../components/DeleteButton';
import TableForm from '../../components/TableForm';
import TagInput from '../../components/Form/TagInput';

@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch),
				naviActions: bindActionCreators(naviActions, dispatch),
				tabActions: bindActionCreators(tabActions, dispatch)}
	}, null, {withRef: true })
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'image.fetch',
			save: 'image.save',
			remove: 'image.delete'
		};

		this.changeEvent = 'image.change';
		this.savePushState = '/image';

		this.messages = {
			remove: 'Opravdu si přejete obrázek odstranit?',
			notfound: 'Obrázek nenalezen!'
		};

		this.schema = {
			title: {
				class: TextInput,
				label: 'Název',
				autoFocus: !props.id
			},
			tags: {
				class: TagInput,
				label: 'Štítky',
				dynamicProps: () => {
					return {loading: this.state.detectTagsPending}
				}
			},
			image: {
				class: ImageUpload,
				label: 'Obrázek',
				galleryPicker: false,
				onChange: (val) => {
					if (val) {
						if (!this.props.id) {
							const api = new ApiClient();
							this.setState({detectTagsPending: true});
							api.call('image.detectTags', {image: val.get('orig')}).then(({tags}) => {
								this.setState({detectTagsPending: false});
								const set = {};
								set.tags = tags;
								const row = this.form.getValues().toJS();
								if (!row.title || row.title.length == 0) {
									set.title = tags[0];
								}
								this.form.setValue(set)
							});
						}
					}
				}
			},
		};
		this.form = new FormManager(this.schema);
		this.state = {
			detectTagsPending: false
		}
	}

	shouldComponentUpdate(nextProps, nextState) {
		return super.shouldComponentUpdate(nextProps, nextState);// || this.state.detectTagsPending != nextState.detectTagsPending;
	}

	componentDidMount() {
		this.form.on('change', (key, value) => {
			if (key == 'title') {
				this.title = value;
			}
			this.changed = true;
		});
		super.componentDidMount();
	}

	updateTab(data) {
		this.props.updateTab({title: data.title});
	}

	onSave(data) {
		if (this.props.onSave) {
			this.form.reset();
			this.props.onSave(data);
		}
	}

	render() {

		const canEdit = true;

		const saveCloseButton = <LoadingButton
			disabled={!canEdit}
			title="Uložit a zavřít záložku"
			loading={!!(this.props.form && this.props.form.get('saving'))}
			onClick={()=>this.save(true)}
		/>;

		const saveButton = <LoadingButton
			disabled={!canEdit}
			bsStyle="default"
			title="Uložit"
			loading={!!(this.props.form && this.props.form.get('saving'))}
			onClick={()=>this.save()}
		/>;

		const deleteButton = this.props.id > 0 && <DeleteButton onClick={()=>this.remove()} />;
		const values = this.form.getValues().toJS();

		return (
			<AppForm id={this.props.tabid} form={this.form} ref="form">
					<Toolbar title="Obrázek" visible={!this.props.popup}>
						<ButtonToolbar>
							{saveCloseButton}
							{saveButton}
							{deleteButton}
						</ButtonToolbar>
					</Toolbar>
					<div className="row">
						<div className={!this.props.popup ? 'col-xs-10' : ''}>
							<TableForm>
								{Object.keys(this.schema).map((key) => {
									return <FormRow key={key} visible={this.schema[key].visible} name={key} labelWidth={135}/>
								})}
								<FormRow className="buttons" visible={this.props.popup}>
									{saveCloseButton}
								</FormRow>
							</TableForm>
						</div>
					</div>
					{this.props.popup &&
					<div className="modal-footer" style={{margin: -20, marginTop: 20}}>
						<Button onClick={() => this.props.onClose()} bsStyle="link">Storno</Button>
						{saveCloseButton}
					</div>}
			</AppForm>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Image/Form.js